import { render, staticRenderFns } from "./coperbizitravelonlineaktarim.vue?vue&type=template&id=167d609a"
import script from "./coperbizitravelonlineaktarim.vue?vue&type=script&lang=js"
export * from "./coperbizitravelonlineaktarim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports